export default [{
    dictKey:'',
    dictValue:'全部'
},{
    dictKey:'0',
    dictValue:'有效'
},{
    dictKey:'1',
    dictValue:'失效'
},];



// WEBPACK FOOTER //
// ./src/service/constant/CardDeleteStatus.js